import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Dos = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh'}}><b>Solution</b></Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}><ul><li>iMoAge&apos;s project implements <b>a Point of Care biosensor </b> so that people can carry it out at home and be certain of the high affinity and accuracy it provides by measuring inflammation levels by <b>quantifying 4 specific molecules consistently reported as biomarkers of inflammation (CXCL9, CRP, IL-6 and TNF-α).</b></li><li>The biosensor consists of a multiplex lateral flow assay with a barcode detection for semiquantitative results and using aptamers for detecting the specific molecule.</li><li>This will <b>solve time and economic problems while monitoring the aging process.</b></li></ul></Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-25.png'/>
          <p><b>Fig. 6.2</b> Complementary image of the <q>Solution</q> section in the Business Model Canva. Our solution to the lack of geroscience tools for diagnosis is iMoAge.</p>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dos;
